import { FC, ReactNode } from 'react'
import cn from 'classnames'
import classes from './index.module.css'

export interface LeadProfileModalBlockProps {
  /** Мелкая верхняя строка (uppercase); цвет задаётся `titleColor`, по умолчанию как у блока воронки. */
  title?: string
  /** Мелкая пометка рядом с `title` (без uppercase), например «по сделке». */
  titleHint?: ReactNode
  /** Крупный заголовок под `title`; если не передан — не рендерится. */
  subtitle?: string
  /** Цвет мелкого `title`; не задан — цвет по умолчанию из стилей блока. */
  titleColor?: string | null
  /** Правая часть шапки (слот). */
  headerRight?: ReactNode
  /** Цвет левой полоски; если не задан — градиент по умолчанию. */
  accentColor?: string | null
  children: ReactNode
  'aria-label'?: string
  className?: string
  /** Доп. класс на внутреннюю оболочку (контент под шапкой), например flex-растяжение. */
  innerClassName?: string
  /** Уменьшенные отступы и шрифт шапки (правая колонка модалки). */
  compact?: boolean
}

const LeadProfileModalBlock: FC<LeadProfileModalBlockProps> = ({
  title,
  titleHint,
  subtitle,
  titleColor,
  headerRight,
  accentColor,
  children,
  'aria-label': ariaLabel,
  className,
  innerClassName,
  compact = false,
}) => {
  const accentTrimmed =
    accentColor != null && String(accentColor).trim() !== ''
      ? String(accentColor).trim()
      : null

  const accentStyle = accentTrimmed
    ? {
        background: accentTrimmed,
        boxShadow:
          'calc(0.0625 * var(--adapt-rem)) 0 calc(0.375 * var(--adapt-rem)) var(--color-shadow-medium)',
      }
    : undefined

  const showAside = headerRight != null

  const titleTrimmed =
    title != null && String(title).trim() !== '' ? String(title).trim() : ''
  const titleColorTrimmed =
    titleColor != null && String(titleColor).trim() !== ''
      ? String(titleColor).trim()
      : null
  const titleStyle = titleColorTrimmed
    ? { color: titleColorTrimmed }
    : undefined

  return (
    <section
      className={cn(classes.root, compact && classes.compact, className)}
      aria-label={ariaLabel}
    >
      <div className={classes.glow} aria-hidden />
      <div className={classes.accent} aria-hidden style={accentStyle} />
      <div className={cn(classes.inner, innerClassName)}>
        <header className={classes.header}>
          <div className={classes.titleCol}>
            {titleTrimmed ? (
              <span className={classes.title} style={titleStyle}>
                {titleTrimmed}
                {titleHint != null && titleHint !== '' ? (
                  <span className={classes.titleHint}>{titleHint}</span>
                ) : null}
              </span>
            ) : null}
            {subtitle ? (
              <h3 className={classes.subtitle}>{subtitle}</h3>
            ) : null}
          </div>
          {showAside ? (
            <div className={classes.headerAside}>{headerRight}</div>
          ) : null}
        </header>
        {children}
      </div>
    </section>
  )
}

export default LeadProfileModalBlock
